export default (theme) => {
  return {
    select: {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },

    groupLabel: {
      fontWeight: 'bold',
      backgroundColor: theme.palette.common.fadeGrey,
      '&&': {
        opacity: 1,
      },
    },

    chip: {
      margin: theme.spacing(0, 0.6, 0, 0),
      height: '20px',
    },

    chipDeleteIcon: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  }
}
